import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// import LiquidityCard from '../../components/Pools/LiquidityCard';
import Button from "../../components/Common/Button";
import TransactionDialog from "../../components/Common/TransactionDialog";
import TableCard from "../../components/Pools/TableCard";
import SearchInput from "../../components/SearchInput";
import PoolsBannerImg from "../../imgs/pools_banner.png";
import { getTransactionByHash } from "../../libs/aptos_sdk";
import {
  get_all_pairs,
  get_current_lp,
  create_gauge,
} from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import { end_loading, start_loading } from "../../store/loading";
import { sleep } from "../../utils/common";

const Pools = () => {
  const { signAndSubmitTransaction } = useWallet();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accountAddresses = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );

  const [allPair, setAllPair] = useState<any[]>([]);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [step, setStep] = useState<number>(0);
  const [txn, setTxn] = useState<string>("");

  useEffect(() => {
    const fetch = async () => {
      dispatch(start_loading());

      let data: any;
      if (accountAddresses) {
        data = await get_current_lp(accountAddresses);
        window.console.log("Pairs, Data: ", data);
      } else {
        setAllPair([]);
        dispatch(end_loading());
      }

      const allPairs = async () => {
        const pairs: any = await get_all_pairs();
        setAllPair(pairs);
        dispatch(end_loading());
      };

      await allPairs();
    };

    if (accountAddresses) {
      fetch();
    } else {
      setAllPair([]);
      dispatch(end_loading());
    }
  }, [accountAddresses, dispatch]);

  const addLiquidity = () => {
    navigate("/pools/create_liquidity");
  };

  const handleCloseAlert = () => setOpenAlert(false);

  const handle_create_gauge = async (x: string, y: string) => {
    setTxn("");
    setOpenAlert(true);
    setStep(0);

    const data = await create_gauge(signAndSubmitTransaction, x, y);

    setTxn(data.hash);

    setStep(1);
    let transaction;
    while (!transaction) {
      try {
        transaction = await getTransactionByHash(data.hash);
      } catch {
        await sleep(500);
      }
    }
    setStep(2);
  };
  return (
    <div className="flex min-h-screen py-16 max-xl:flex-col max-xl:items-center">
      <div className="flex flex-col gap-8 w-full p-10 max-sm:px-4">
        <div className="bg-white bg-opacity-10 rounded-lg flex justify-between max-md:flex-col max-md:items-center max-md:p-4 max-md:gap-4">
          <div className="flex flex-col w-full gap-4 p-9 max-md:p-0">
            <div className="flex items-center justify-between">
              <p className="text-4xl text-white max-sm:text-xl max-sm:font-bold">
                Pools
              </p>
              <Button
                className="text-base px-10 font-normal"
                onClick={addLiquidity}
              >
                Add Liquidity
              </Button>
            </div>
            <p className="text-white text-base">
              Add liquidity and earn weekly rewards
            </p>
          </div>
          <img
            src={PoolsBannerImg}
            alt="banner"
            className="w-40 h-40 flex-shrink-0"
          />
        </div>
        <SearchInput />
        <TableCard allPair={allPair} create_gauge={handle_create_gauge} />
      </div>
      <div>
        <TransactionDialog
          openAlert={openAlert}
          txn={txn}
          title="Create Gauge for the pool"
          step={step}
          handleCloseAlert={handleCloseAlert}
        />
      </div>
    </div>
  );
};

export default Pools;
